import { useVoiceAssistantStore } from '../store/useVoiceAssistantStore';

/**
 * React surface over the workspace slice of {@link useVoiceAssistantStore}.
 * The overlay chrome reads workspace state + these actions; voice-session
 * concerns (composer, timeline, mute) stay on `useVoiceAssistant`.
 */
export function useVoiceWorkspace() {
  const workspace = useVoiceAssistantStore((s) => s.workspace);
  const infoCards = useVoiceAssistantStore((s) => s.infoCards);
  const drafts = useVoiceAssistantStore((s) => s.drafts);
  const expandedDraftId = useVoiceAssistantStore((s) => s.expandedDraftId);
  const stashedDraft = useVoiceAssistantStore((s) => s.stashedDraft);
  const minimize = useVoiceAssistantStore((s) => s.minimizeWorkspace);
  const restore = useVoiceAssistantStore((s) => s.restoreWorkspace);
  const closeWorkspace = useVoiceAssistantStore((s) => s.closeWorkspace);
  const setContent = useVoiceAssistantStore((s) => s.setWorkspaceContent);
  const setStatus = useVoiceAssistantStore((s) => s.setWorkspaceStatus);
  const setCreateError = useVoiceAssistantStore((s) => s.setWorkspaceCreateError);
  const restoreStashedDraft = useVoiceAssistantStore((s) => s.restoreStashedDraft);
  const presentInfoCard = useVoiceAssistantStore((s) => s.presentInfoCard);
  const setExpandedDraftId = useVoiceAssistantStore((s) => s.setExpandedDraftId);
  const discardDraft = useVoiceAssistantStore((s) => s.discardDraft);

  return {
    workspace,
    infoCards,
    drafts,
    expandedDraftId,
    stashedDraft,
    minimize,
    restore,
    closeWorkspace,
    setContent,
    setStatus,
    setCreateError,
    restoreStashedDraft,
    presentInfoCard,
    setExpandedDraftId,
    discardDraft,
  };
}
